import { render } from "./TemplateImageInput.vue?vue&type=template&id=64f93f71&scoped=true"
import script from "./TemplateImageInput.vue?vue&type=script&lang=js"
export * from "./TemplateImageInput.vue?vue&type=script&lang=js"

import "./TemplateImageInput.vue?vue&type=style&index=0&id=64f93f71&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f93f71"]])

export default __exports__